module.exports = __webpack_public_path__ + "img/mgh-kanazawa.cc01f574.jpg";